import { render } from "./AnalyticComponent.vue?vue&type=template&id=66726866"
import script from "./AnalyticComponent.vue?vue&type=script&lang=js"
export * from "./AnalyticComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/settings/analytics/AnalyticComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "66726866"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('66726866', __exports__)) {
    api.reload('66726866', __exports__)
  }
  
  module.hot.accept("./AnalyticComponent.vue?vue&type=template&id=66726866", () => {
    api.rerender('66726866', render)
  })

}


export default __exports__